import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../../../library/link/link';
import { AngleRightLightIcon } from '../../../../../../shared/icons/icons';

import './cms-featured-article.scss';

function CmsFeaturedArticle(props) {
  const { id, description, heading, image, isFixedWidth, link } = props;

  return (
    <article
      id={id}
      styleName={isFixedWidth ? 'article article-fixed' : 'article'}
    >
      <img
        alt={image?.altText}
        draggable="false"
        src={image?.url}
        styleName="image"
      />
      <div styleName="info">
        <h3 styleName="heading">{heading}</h3>
        <p styleName="description">{description}</p>

        <Link styleName="link" to={link.href}>
          {link.text}
          <AngleRightLightIcon styleName="icon" />
        </Link>
      </div>
    </article>
  );
}

CmsFeaturedArticle.propTypes = {
  description: PropTypes.string,
  heading: PropTypes.string,
  id: PropTypes.string,
  image: PropTypes.object,
  isFixedWidth: PropTypes.bool,
  link: PropTypes.object
};

export default CmsFeaturedArticle;
